/* eslint-disable promise/always-return, promise/catch-or-return -- some unreadable magic happens here, better not to touch */
// FLAGS: none
// Lazily loads web-vitals and hands each metric to the callback main.tsx supplies (the App Insights reporter).
import { ReportCallback } from "web-vitals";

const reportWebVitals = (onPerfEntry?: ReportCallback) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
